export default __webpack_public_path__ + "static/media/DSC_8093-editedinvestors.73465dfe.png";